<template>
  <div class="vmp-live-lottery">
    <vh-dialog
      :visible.sync="dialogVisible"
      @close="close"
      :close-on-click-modal="false"
      :modal="true"
      append-to-body
      class="lottery-dialog"
      width="920px"
    >
      <div slot="title">
        <i
          class="vh-iconfont vh-line-arrow-left"
          @click="returnStep('list')"
          style="font-size: 14px; cursor: pointer"
          v-if="!isLotteryList && !onlySetting"
        ></i>
        {{ lotteryTitle }}
        <span class="notice" v-if="lotterAct == 'list'">{{ $t('host.k_582001') }}</span>
      </div>
      <div class="vmp-live-lottery_wrapper">
        <!-- 抽奖列表 -->
        <lottery-list
          ref="lotteryList"
          v-if="isLotteryList && !onlySetting"
          @returnStep="returnStep"
        ></lottery-list>
        <!-- 抽奖设置 -->
        <template v-else-if="!isLotteryList">
          <vh-tabs
            v-model="activeName"
            @tab-click="handleClick"
            :class="{ 'lottery-readonly': this.lotterAct == 'view' }"
          >
            <vh-tab-pane :label="$t('host.k_582002')" name="lottery">
              <lottery-setting
                ref="lottery"
                @returnStep="returnStep"
                @success="handleSucess"
              ></lottery-setting>
            </vh-tab-pane>
            <vh-tab-pane :label="$t('host.k_582003')" name="condition" :disabled="isCreateLottery">
              <condition-setting
                :readOnly="this.lotterAct == 'view'"
                ref="condition"
                @returnStep="returnStep"
                @success="handleSucess"
              ></condition-setting>
            </vh-tab-pane>
            <vh-tab-pane :label="$t('host.k_582004')" name="reward" :disabled="isCreateLottery">
              <reward-setting
                ref="reward"
                @returnStep="returnStep"
                @success="handleSucess"
              ></reward-setting>
            </vh-tab-pane>
            <vh-tab-pane name="prize" :disabled="isCreateLottery" class="tab-prize">
              <span slot="label">
                {{ $t('host.k_582005') }}
                <vh-tooltip effect="dark" placement="right" style="margin-left: 3px">
                  <i class="vh-iconfont vh-line-question"></i>
                  <div slot="content">
                    {{ $t('host.k_582006') }}
                    <br />
                    {{ $t('host.k_582007') }}
                    <br />
                    {{ $t('host.k_582008') }}
                  </div>
                </vh-tooltip>
              </span>
              <prize-list ref="prize" @returnStep="returnStep" @success="handleSucess"></prize-list>
            </vh-tab-pane>
          </vh-tabs>
        </template>
      </div>
    </vh-dialog>
  </div>
</template>
<script>
  import lotteryList from './components/lottery-list.vue';
  import lotterySetting from './components/lottery-setting.vue';
  import prizeList from './components/prize-list.vue';
  import rewardSetting from './components/reward-setting.vue';
  import conditionSetting from './components/condition-setting.vue';
  import { useLotteryServer } from 'middle-domain';
  import { emitter, EMIT_DEFINE } from '@/app-shared/utils/emitter.js';
  export default {
    name: 'VmpLotteryLive',
    data() {
      return {
        dialogVisible: false,
        isLotteryList: true,
        isCreateLottery: false,
        lotteryTitle: this.$t('host.k_582009'),
        lotterAct: 'list',
        activeName: 'lottery',

        // 仅仅设置，不展示列表
        onlySetting: false,
        hasSuccessSetting: false
      };
    },
    components: {
      lotteryList,
      lotterySetting,
      prizeList,
      conditionSetting,
      rewardSetting
    },
    beforeCreate() {
      this.lotteryServer = useLotteryServer({
        mode: 'live'
      });
    },
    methods: {
      /**
       * @description 打开整个抽奖组件
       */
      async open() {
        this.hasSuccessSetting = false;
        this.dialogVisible = true;
        this.activeName = 'lottery';
        this.lotteryTitle = this.$t('host.k_582009');
        this.lotterAct = 'list';
        if (!this.onlySetting) {
          this.lotteryServer.recordLotteryInfo();
          this.$nextTick(() => {
            this.$refs.lotteryList.getLotteryList();
          });
        }
      },
      handleClick(tab) {
        let name = tab.name;
        this.$refs[name].initComponent();
      },
      returnStep(name) {
        if (name === 'create') {
          this.isLotteryList = false;
          this.isCreateLottery = true;
          this.lotteryTitle = this.$t('host.k_582010');
          this.lotterAct = 'create';
          this.activeName = 'lottery';
        } else if (name === 'edit') {
          this.lotteryTitle = this.$t('host.k_582011');
          this.lotterAct = 'edit';
          this.isLotteryList = false;
          this.isCreateLottery = false;
          this.activeName = 'lottery';
        } else if (name === 'view') {
          this.lotteryTitle = this.$t('host.k_582012');
          this.lotterAct = 'view';
          this.isLotteryList = false;
          this.isCreateLottery = false;
          this.activeName = 'lottery';
        } else if (name === 'list') {
          this.isLotteryList = true;
          this.activeName = 'lottery';
          this.lotteryTitle = this.$t('host.k_582009');
          this.lotterAct = 'list';
          this.$nextTick(() => {
            this.$refs.lotteryList.getLotteryList();
          });
        } else {
          this.isLotteryList = false;
          this.isCreateLottery = false;
          // this.activeName = name;
          // this.handleClick({ name });
          // console.log(name, '???!23');
        }
      },
      handleLottery(flag) {
        flag ? this.open() : this.close();
      },
      close() {
        this.dialogVisible = false;
        this.isLotteryList = true;
        this.isCreateLottery = true;
        this.activeName = 'lottery';

        if (this.onlySetting && this.hasSuccessSetting) {
          emitter.emit(EMIT_DEFINE.live_lottery_setting_success);
        }
      },
      handleSucess(data) {
        this.hasSuccessSetting = true;
      },
      toggleLotterySetting(options) {
        console.log('lele options :', options);
        if (['create', 'edit', 'view'].includes(options.act)) {
          // 仅展示创建和编辑对话框内容
          this.onlySetting = true;
          switch (options.act) {
            case 'create':
              this.lotteryServer.recordLotteryInfo();
              break;
            case 'edit':
              this.lotteryServer.recordLotteryInfo(options.args.id);
              break;
            case 'view':
              this.lotteryServer.recordLotteryInfo(options.args.id);
              break;
          }
          this.open();
          this.returnStep(options.act);
        }
      }
    },
    created() {
      emitter.on(EMIT_DEFINE.live_lottery_setting, this.toggleLotterySetting);
    },
    beforeDestroy() {
      emitter.off(EMIT_DEFINE.live_lottery_setting, this.toggleLotterySetting);
    }
  };
</script>
<style lang="less">
  .vmp-live-lottery {
    &_wrapper {
      .vh-line-question {
        color: #666;
        font-size: 13px;
      }
    }
    .dialog-footer {
      display: flex;
      justify-content: flex-end;
    }
  }
  .lottery-dialog {
    .notice {
      font-size: 12px;
      color: #999;
      margin-left: 10px;
    }
  }
  .vh-switch__label {
    color: #8c8c8c;
    font-weight: 400;
    &.is-active {
      color: #595959;
    }
  }
  .lottery-readonly {
    .vh-tabs__content::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(255, 255, 255, 0.5);
      z-index: 1;
    }
    .tab-prize .prize-list_wrapper {
      position: relative;
      z-index: 10;
      .vh-table::after {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.5);
        z-index: 11;
      }
    }
  }
</style>
